(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["tec-section-banner"] && !window.DesignMode) return;
  try {
    
  $('.dropdown > .caption').on('click', function () {
    $(this).parent().toggleClass('open');
  });

  $('.dropdown > .list > .item').on('click', function () {
    $('.dropdown > .list > .item').removeClass('selected');
    $(this)
      .addClass('selected')
      .parent()
      .parent()
      .removeClass('open')
      .children('.caption')
      .children('.item-text')
      .children('p')
      .text($(this).text());

    $('.item-money').text($(this).attr('savings-data'));
  });

  $(document).on('keyup', function (evt) {
    if ((evt.keyCode || evt.which) === 27) {
      $('.dropdown').removeClass('open');
    }
  });

  $(document).on('click', function (evt) {
    if ($(evt.target).closest('.dropdown > .caption').length === 0) {
      $('.dropdown').removeClass('open');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tec-section-product"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const openButtons = document.querySelectorAll('.tec-product-item-link');
      const closeButtons = document.querySelectorAll('.tec-popup-container button'); 
      const overlays = document.querySelectorAll('.modal-popup-tool-tip .overlay');
      const popupContainer = document.querySelector('.modal-popup-tool-tip');
      const popupContainers = document.querySelectorAll('.modal-popup-tool-tip');

      function hidePopup (popupContainers) {
        setTimeout( () => { popupContainers.forEach((popupContainer) => {
              console.log(1111);
                popupContainer.style.display = "none";
              });
          }, 2000)
      }
      if(openButtons){
        hidePopup(popupContainers);
      }
      openButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          const productItems = document.querySelectorAll('.tec-product-item');
          productItems[index].classList.add('popup-active');
          productItems[index].querySelector('.modal-popup-tool-tip').style.display = "block";
        });
      });
      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          const productItems = document.querySelectorAll('.tec-product-item');
          productItems.forEach(item => {
            item.classList.remove('popup-active');
            hidePopup(popupContainers);
          });
        });
      });
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', () => {
          const productItems = document.querySelectorAll('.tec-product-item');
          productItems.forEach(item => {
            item.classList.remove('popup-active');
            hidePopup(popupContainers);
          });
        });
      });
    });

  } catch(e) { console.error(e); }
})();

})();
